// eslint-disable-next-line import/no-extraneous-dependencies
import {
  scaleBand,
  scaleLinear,
  scaleTime,
  scaleOrdinal,
  scaleLog,
} from 'd3-scale';

function parameterCheck(config) {
  // const { domain, range } = config;

  if (!config.domain || !config.range) {
    console.error('No [domain] or [range] specified!');
    return { resume: false };
  }

  return { resume: true };
}

export function linearScale(config) {
  const { resume } = parameterCheck(config);
  if (!resume) return false;

  const scale = scaleLinear()
    .range(config.range)
    .domain(config.domain)
    .nice(config.nice);

  return scale;
}

export function logScale(config) {
  const { resume } = parameterCheck(config);
  if (!resume) return false;

  const scale = scaleLog()
    .range(config.range)
    .domain(config.domain)
    .nice(config.nice);

  return scale;
}


export function timeScale(config) {
  const { resume } = parameterCheck(config);
  if (!resume) return false;

  const scale = scaleTime()
    .range(config.range)
    .domain(config.domain)
    .nice(config.nice);

  return scale;
}

export function ordinalScale(config) {
  const { resume } = parameterCheck(config);
  if (!resume) return false;

  const scale = scaleOrdinal()
    .range(config.range)
    .domain(config.domain);

  return scale;
}

export function bandScale(config) {
  const { resume } = parameterCheck(config);
  if (!resume) return false;

  const scale = scaleBand()
    .range(config.range)
    .domain(config.domain)
    .padding(config.padding || 0);

  return scale;
}
